define(['./base', 'underscore', 'jquery', '../../utils/globalEvents', '../../utils/likePostRequest'], function (
  Helper,
  _,
  $,
  events,
  likePostRequest
) {
  return Helper.extend({
    template: false,

    options: {
      activeClass: 'active',
      isGuest: true
    },

    ui: {
      btn: '.js-like-btn',
      voteCount: '.js-vote-count'
    },

    events: {
      'click @ui.btn': 'toggleVote'
    },

    initialize: function (options) {
      Helper.prototype.initialize.call(this)
      if (options.hasCurrentUserLiked == null) { throw new Error('Missing hasCurrentUserLiked param') }
      if (options.currentVotes == null) { throw new Error('Missing currentVotes param') }

      this.currentVotes = parseInt(options.currentVotes, 10)
      this.hasCurrentUserLiked = !!options.hasCurrentUserLiked
    },

    toggleVote: function (e) {
      e.preventDefault()
      if (this.options.isGuest) { return events.commands.execute('modal:login:show') }
      if (this._isLoading) return

      this.currentVotes =
        parseInt(this.currentVotes, 10) + (this.hasCurrentUserLiked ? -1 : 1)
      this.hasCurrentUserLiked = !this.hasCurrentUserLiked

      this.ui.voteCount.text(this.currentVotes)

      this.$el.toggleClass(this.options.activeClass, this.hasCurrentUserLiked)

      this._isLoading = true
      var self = this
      likePostRequest(this.options.threadId, this.options.postId, !this.options.hasCurrentUserLiked, () => {
        self.options.hasCurrentUserLiked = !self.options.hasCurrentUserLiked
        self._isLoading = false
      })
    }
  })
})
